import { FILE_SCOPE_EMAIL } from '../../../../constants/file'
import { useInitData, useScreen } from '../../../../hooks'
import { ProfileDocumentsWidget } from '../../../Widget'
import { useEmailProfileContext } from '../../Email.hooks'
import { EmailProfileAISummaryWidget } from '../EmailProfileAISummaryWidget'
import { EmailProfileWidgetAttachedServiceRequests } from '../EmailProfileWidgetAttachedServiceRequests'
import { EmailProfileWidgetCopiedTo } from '../EmailProfileWidgetCopiedTo'
import { EmailProfileWidgetCustomFolders } from '../EmailProfileWidgetCustomFolders'
import { EmailProfileWidgetParticipants } from '../EmailProfileWidgetParticipants'

function EmailProfileWidgetList({
  foldersWidgetClassName,
  isSkeleton,
  widgetClassName,
}) {
  const { ai_features: aiFeatures } = useInitData()

  const { widgetsData } = useEmailProfileContext()

  const { isMobileScreenSize } = useScreen()

  return (
    <>
      {aiFeatures?.email_summary_generation ? (
        <EmailProfileAISummaryWidget isSkeleton={isSkeleton} />
      ) : null}
      <EmailProfileWidgetParticipants
        initiallyExpanded={!isMobileScreenSize}
        isSkeleton={isSkeleton}
        participants={widgetsData?.participants.items}
        widgetProps={{
          className: widgetClassName,
        }}
      />
      <ProfileDocumentsWidget
        files={widgetsData?.files.items}
        initiallyExpanded={!isMobileScreenSize}
        isSkeleton={isSkeleton}
        scope={FILE_SCOPE_EMAIL}
        widgetProps={{
          className: widgetClassName,
        }}
      />
      <EmailProfileWidgetAttachedServiceRequests
        initiallyExpanded={!isMobileScreenSize}
        isSkeleton={isSkeleton}
        requests={widgetsData?.linked_requests.items}
        widgetProps={{
          className: widgetClassName,
        }}
      />
      <EmailProfileWidgetCopiedTo
        initiallyExpanded={!isMobileScreenSize}
        isSkeleton={isSkeleton}
        items={widgetsData?.copiedTo}
        widgetProps={{
          className: widgetClassName,
        }}
      />
      <EmailProfileWidgetCustomFolders
        folders={widgetsData?.folders.items}
        initiallyExpanded={!isMobileScreenSize}
        isSkeleton={isSkeleton}
        widgetProps={{
          className: foldersWidgetClassName,
        }}
      />
    </>
  )
}

export default EmailProfileWidgetList
